
class ParameterLocks {
    constructor() {
        this.parameterLocks = [];
    }

    addParameterLock(
        trackNumber,
        groupNumber,
        sendNumber,
        effectNumber,
        parameter)
    {
        this.parameterLocks.push(
            new ParameterLock(
                trackNumber,
                groupNumber,
                sendNumber,
                effectNumber,
                parameter));
    }

    deleteParameterLock(parameterLock) {
        let index = this.parameterLocks.indexOf(parameterLock);
        if (index > -1) {
            this.parameterLocks.splice(index, 1);
        }
    }

    fromJson(json, sequencerEngine) {
        for (let i in json) {
            let parameterLockJson = json[i];
            let parameter = parameterLockJson.effectNumber === undefined ?
                this.getTrackParameterFromJson(parameterLockJson, sequencerEngine) :
                this.getEffectParameterFromJson(parameterLockJson, sequencerEngine);
            if (parameter === undefined) {
                continue;
            }

            this.parameterLocks.push(new ParameterLock(
                parameterLockJson.trackNumber,
                parameterLockJson.groupNumber,
                parameterLockJson.sendNumber,
                parameterLockJson.effectNumber,
                parameter));
        }
    }

    getTrackParameterFromJson(json, sequencerEngine) {
        let trackNumber = json.trackNumber;
        if (trackNumber === undefined) {
            return undefined;
        }

        let track = sequencerEngine.tracks[trackNumber];
        let trackData = track.trackData;

        // find the parameter inside the effect (via the name-- assumes
        // there are no duplicate parameter-names within an effect))
        let parameterName = json.parameter.name;
        let foundParameters = trackData.parameters.filter(parameter => parameter.name === parameterName);
        if (foundParameters.length < 1) {
            return undefined;
        }
        let parameter = foundParameters[0];
        parameter.min = json.parameter.min;
        parameter.max  = json.parameter.max;

        return parameter;
    }

    getEffectParameterFromJson(json, sequencerEngine) {
        let effect = undefined;
        if (json.trackNumber !== undefined) {
            let track = sequencerEngine.tracks[json.trackNumber];
            effect = track.effects[json.effectNumber];
        } else if (json.groupNumber !== undefined) {
            let group = sequencerEngine.groups.groups[json.groupNumber];
            if (group === undefined) {
                return undefined;
            }
            effect = group.effects[json.effectNumber];
        } else if (json.sendNumber !== undefined) {
            let send = sequencerEngine.sends.sends[json.sendNumber];
            effect = send.effects[json.effectNumber];
        }  

        if (effect === undefined) {
            return undefined;
        }

        // find the parameter inside the effect (via the name-- assumes
        // there are no duplicate parameter-names within an effect))
        let parameterName = json.parameter.name;
        let foundParameters = effect.parameters.filter(parameter => parameter.name === parameterName);
        if (foundParameters.length < 1) {
            return undefined;
        }
        let parameter = foundParameters[0];
        parameter.min = json.parameter.min;
        parameter.max  = json.parameter.max;

        return parameter;
    }

    getJson() {
        return this.parameterLocks.map(l => l.getJson());
    }
}

class ParameterLock {
    constructor(trackNumber, groupNumber, sendNumber, effectNumber, parameter) {
        this.trackNumber = trackNumber;
        this.sendNumber = sendNumber;
        this.groupNumber = groupNumber;
        this.effectNumber = effectNumber;
        this.parameter = parameter;
    }

    getJson() {
        let json = {
            parameter: this.parameter.getJson(),
            effectNumber: this.effectNumber
        };

        if (this.trackNumber !== undefined) {
            json.trackNumber = this.trackNumber;
        }

        if (this.groupNumber !== undefined) {
            json.groupNumber = this.groupNumber;
        }

        if (this.sendNumber !== undefined) {
            json.sendNumber = this.sendNumber;
        }

        return json;
    }
}

export default ParameterLocks;
